












































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import draggable from "vuedraggable";
import ControlTransferCmp from "./controlMobans/controlTransferCmp.vue";
import axios, { axiosM, resHandle } from "../../../../plugins/axios";
import { GetDictionary } from "@/request/moban";
import { labels, defaultList } from "./controlMobans/ziduans";
@Component({
  components: {
    draggable,
    ControlTransferCmp,
  },
})
export default class ControlCmp extends Vue {
  @Prop()
  private cFangshi: any;
  @Prop()
  private groupName: any;
  @Prop()
  private cTemplate: any;
  @Prop()
  private isHideTop: any;
  private labels: any = labels;
  private ziduans: any = {};
  private resultList: any[] = [];
  // 修改名称弹窗
  private ifShowMobanNameDialog: boolean = false;
  private mobanName: any = "";
  /**
   * @description 返回分组页
   */
  private backToSecond() {
    this.$router.push(
      "/main/project/project-create-second/" + this.cFangshi.project_id
    );
  }
  /**
   * @description 返回模板列表页
   */
  private backToList() {
    this.$emit("cStateChange", "list");
  }
  /**
   * @description 切换为数据字典
   */
  private goToCustomMoban() {
    this.$emit("cStateChange", "custom");
  }
  /**
   * @description 切换系统模板
   */
  private goToSystemMoban() {
    this.$emit("cStateChange", "system");
  }
  /**
   * @description 初步加载时，给所有字段套壳
   */
  private handleMountedZiduans() {
    const source: any[] = this.cTemplate["模板"];
    source.map((item: any, index: any) => {
      if (item.big_title) {
        this.resultList.push({
          label: "标题",
          content: {
            title: item.big_title,
            type: "标签",
          },
          count: 0,
        });
      }
      if (item.top_title) {
        this.resultList.push({
          label: "问题组",
          content: {
            title: item.top_title,
            type: "问题组",
          },
          count: 0,
        });
      }
      if (item.type === "单选" || item.type === "计分单选") {
        this.resultList.push({ label: "单选题", content: item, count: 0 });
      }
      if (item.type === "多选" || item.type === "计分多选") {
        this.resultList.push({ label: "多选题", content: item, count: 0 });
      }
      if (item.type === "文件") {
        this.resultList.push({ label: "文件上传", content: item, count: 0 });
      }
      if (item.type === "固定单位数字" || item.type === "可变单位数字") {
        this.resultList.push({ label: "数值题", content: item, count: 0 });
      }
      if (item.type === "计分条") {
        this.resultList.push({ label: "标尺", content: item, count: 0 });
      }
      if (item.type === "字符串" || item.type === "文本域") {
        this.resultList.push({ label: "文本题", content: item, count: 0 });
      }
      if (item.type === "单个时间") {
        this.resultList.push({ label: "时间", content: item, count: 0 });
      }
    });
    this.reCalResultListIndex();
  }
  /**
   * @description 添加字段
   */
  private addItem(item) {
    let count: any = 0;
    this.resultList.map((i: any) => {
      if (i.label === "标题" || i.label === "问题组") {
        count++;
      }
    });
    const obj = _.cloneDeep(item);
    obj.count = count;
    obj.content = defaultList[item.label];
    this.resultList.push(obj);
  }
  /**
   * @description 删除某个自定义字段
   */
  private deleteOneZiduan(index) {
    this.resultList.splice(index, 1);
    this.reCalResultListIndex();
  }
  /**
   * @description 重新计算结果序号
   */
  private reCalResultListIndex() {
    let count: number = 0;
    const arr: any[] = [];
    this.resultList.map((item: any, index: any) => {
      let t = 0;
      if (item.label === "标题" || item.label === "问题组") {
        t = count++;
      } else {
        t = count;
      }
      arr.push(t);
    });
    const ne = this.resultList.map((item: any, index: any) => {
      const obj = _.cloneDeep(item);
      obj.count = arr[index];
      return obj;
    });
    this.resultList = ne;
  }
  /**
   * @description 处理字段改变
   */
  private ziduanChange(val, index) {
    this.resultList[index] = val;
    this.$forceUpdate();
  }
  /**
   * @description 拖拽变化
   */
  private dragChange(e) {
    this.reCalResultListIndex();
  }
  /**
   * @description 检查是否符合逻辑
   */
  private validatorResultList() {
    let valid: boolean = true;
    let help: any = "";
    // 清除已有的top_title和big_title
    this.resultList.forEach((item: any) => {
      if (item.content.big_title) {
        delete item.content.big_title;
      }
      if (item.content.top_title) {
        delete item.content.top_title;
      }
    });
    this.resultList.map((item: any, index: any) => {
      if (item.label === "标题" || item.label === "问题组") {
        const nextItem: any = this.resultList[index + 1];
        const nextSecondItem: any = this.resultList[index + 2];
        if (!nextItem) {
          help = "标题或问题组之后必须要有内容";
          valid = false;
          return;
        }
        if (nextItem.label === item.label && item.label === "标题") {
          help = "标题之后不能再接标题";
          valid = false;
          return;
        }
        if (nextItem.label === item.label && item.label === "问题组") {
          help = "问题组之后不能再接问题组";
          valid = false;
          return;
        }
        if (item.label === "标题") {
          if (nextItem.label === "问题组") {
            this.resultList[index + 2]["content"]["big_title"] =
              item.content.title;
            this.resultList[index + 2]["content"]["top_title"] =
              nextItem.content.title;
          } else {
            this.resultList[index + 1]["content"]["big_title"] =
              item.content.title;
          }
        }
        if (item.label === "问题组") {
          if (nextItem.label === "标题") {
            this.resultList[index + 2]["content"]["top_title"] =
              item.content.title;
            this.resultList[index + 2]["content"]["big_title"] =
              nextItem.content.title;
          } else {
            this.resultList[index + 1]["content"]["top_title"] =
              item.content.title;
          }
        }
      }
    });
    if (!valid) {
      this.$message.warning(help);
      return false;
    } else {
      return true;
    }
  }
  /**
   * @description 打开添加量表名称弹窗
   */
  private openInputNameDialog() {
    if (this.validatorResultList()) {
      this.ifShowMobanNameDialog = true;
    }
  }
  /**
   * @description 创建uuid
   */
  private createUuid() {
    const s: any[] = [];
    const hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    const uuid = s.join("");
    return uuid;
  }
  /**
   * @description 使用该模板
   */
  private save() {
    // console.log(this.resultList);
    const finalArr: any[] = [];
    this.resultList.map((item: any, index: any) => {
      if (item.label !== "标题" && item.label !== "问题组") {
        finalArr.push(item);
      }
    });
    // console.log(
    //   finalArr.map((item: any) => {
    //     return item.content;
    //   })
    // );
    if (!this.mobanName) {
      return;
    }
    const params: any = {
      project_id: this.cFangshi.project_id,
      group_id: this.cFangshi.group_id,
      interview_id: this.cFangshi.interview_id,
      名称: this.mobanName,
      模板: finalArr.map((item: any) => {
        if (!item.content.id) {
          item.content.id = this.createUuid();
        }
        return item.content;
      }),
      类别: "自定义模板",
    };
    if (this.cTemplate.template_id) {
      params.template_id = this.cTemplate.template_id;
    }
    // console.log(params);
    axios.post("api/project/template", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("保存成功");
        if (this.isHideTop) {
          this.$router.push({
            path: "/main/project/crf-list",
          });
        } else {
          this.$emit("cStateChange", "list");
        }
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.cTemplate.template_id) {
      this.mobanName = this.cTemplate.name;
      this.handleMountedZiduans();
    }
  }
}
